const points = {
  triangle: "150,20 278,260 22,260",
  pentagon: "150,16 282,112 232,268 68,268 18,112",
  square: "42,42 258,42 258,258 42,258",
};

export default function SacredGeometry({ shape = "square", className = "" }) {
  const polygon = points[shape] || points.square;

  return (
    <svg className={`sacred-geometry geometry-${shape} ${className}`.trim()} viewBox="0 0 300 300" aria-hidden="true">
      <polygon points={polygon} />
      <polygon points={polygon} />
      <polygon points={polygon} />
    </svg>
  );
}
